export default __webpack_public_path__ + "static/media/certificate.10aa1b3d.svg";